module.exports = __webpack_public_path__ + "static/img/property_1_epay.a7f3c15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/property_1_epay.png
// module id = zr6i
// module chunks = 1